export var UserType;
(function (UserType) {
    UserType[UserType["Group"] = 1] = "Group";
    UserType[UserType["Transporter"] = 2] = "Transporter";
    UserType[UserType["Dealer"] = 3] = "Dealer";
})(UserType || (UserType = {}));
export var RoleType;
(function (RoleType) {
    RoleType[RoleType["Admin"] = 1] = "Admin";
    RoleType[RoleType["Transporter"] = 2] = "Transporter";
    RoleType[RoleType["Dealer"] = 3] = "Dealer";
})(RoleType || (RoleType = {}));
